import React, {
  KeyboardEventHandler,
  MouseEventHandler,
  ReactElement,
  useCallback
} from 'react';
import './index.scss';

type Props = {
  onSelect: (target: EventTarget) => void;
  size: string;
  disabled: boolean;
  selected: boolean;
};

const SizeBox: React.FC<Props> = ({
  onSelect,
  size,
  disabled,
  selected
}: Props): ReactElement => {
  const selectedClass = `${selected ? ' sizeBox--selected' : ''}`;
  const disabledClass = `${disabled ? ' sizeBox--disabled' : ''}`;

  const onKeydownCallback = useCallback<KeyboardEventHandler<HTMLDivElement>>(
    e => {
      if (!disabled && e.key === 'Enter') onSelect(e.target);
    },
    [onSelect, selected, disabled]
  );

  const onClickCallback = useCallback<MouseEventHandler<HTMLDivElement>>(
    e => {
      if (!disabled) onSelect(e.target);
    },
    [onSelect, selected, disabled]
  );

  return (
    <div
      role="listbox"
      onKeyDown={onKeydownCallback}
      onClick={onClickCallback}
      tabIndex={0}
      className={`sizeBox${selectedClass}${disabledClass}`}>
      {size}
    </div>
  );
};

export default SizeBox;
